import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import SiteContainer from '../components/common/SiteContainer';
import PageContainer from '../components/common/PageContainer';
import Header from '../components/Header';
import Footer from '../components/Footer';

import '../../public/static/fonts.css'
import '../../public/static/style.css'
import './index.css'

class TemplateWrapper extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      dyslexic: (typeof localStorage !== "undefined" && localStorage.getItem("dyslexic") === "true")
    };
  }

  handleDyslexicChange = () => {
    if(this.state.dyslexic) {
      localStorage.setItem("dyslexic", "false")
      this.setState({ dyslexic: false });
    } else {
      localStorage.setItem("dyslexic", "true")
      this.setState({ dyslexic: true });
    }
  }

  render() {
    let chapter = true;
    const pathRegex = new RegExp("^\\/[\\w\\-\\.]+(\\/)?[\\w\\-\\.]*(\\/)?$", "gi");
    const path = pathRegex.exec(this.props.location.pathname);
    if(path && (path[2] === "/" || (path[1] === "/" && this.props.location.pathname.substr(-1,1) !== "/"))) chapter = false;

    return (
      <SiteContainer dyslexic={this.state.dyslexic}>
        <Helmet
          title="Hitchhiker's Guide to Javascript"
          meta={[
            { name: 'description', content: 'A roaring adventure through the universe of Javascript' },
          ]}
        />
        <PageContainer chapter={chapter}>
          <Header chapter={chapter} onChangeDislexic={this.handleDyslexicChange}/>
          {this.props.children()}
          <Footer chapter={chapter} />
        </PageContainer>
      </SiteContainer>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/blog.js